import { vm } from '../../main';

export default {
    methods: {
        navigateTo(route) {
            vm.$router.push(route).catch(() => {});
        },
    },
};
